import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Activities } from "@/components/Activities";
import { Projects } from "@/components/Projects";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { MobileBar } from "@/components/MobileBar";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#F8FAFC] text-slate-900 antialiased overflow-x-clip">
            <div className="grain" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Activities />
                <Projects />
                <Contact />
            </main>
            <Footer />
            <MobileBar />
        </div>
    );
}

export default App;
